export const BASKET_EXPIRED_MODAL = "BasketExpired";
export const BASKET_EXPIRED_CHANGE_MODAL = "BasketExpiredChange";
export const BUS_MODAL = "Bus";
export const CAMPAIGN_RULES_MODAL = "CampaignRules";
export const DISCARDED_BASKET_MODAL = "DiscardedBasket";
export const DISCARDED_BASKET_CHANGE_MODAL = "DiscardedBasketChange";
export const FORGOT_PASSWORD_MODAL = "ForgotPassword";
export const LOGIN_MODAL = "Login";
export const PARTNER_BUS_NOTICE_MODAL = "PartnerBusNotice";
export const REDEEM_VOUCHER_MODAL = "RedeemVoucher";
export const REIDRECT_TO_PARTNERS_SITE_MODAL = "RedirectToPatnersSite";
export const RESULTS_OUT_OF_DATE_MODAL = "ResultsOutOfDate";
export const SEARCH_DESTINATION_MOBILE_MODAL = "SearchDestinationMobile";
export const SEARCH_PASSENGERS_MOBILE_MODAL = "SearchPassengersMobile";
export const SEND_VOUHER_MODAL = "SendVoucher";
export const UPDATE_BASKET_TIME_MODAL = "UpdateBasketTime";
export const UPDATE_BASKET_TIME_CHANGE_MODAL = "UpdateBasketTimeChange";
export const SEND_PDF_MODAL = "SendPdf";
export const SHOW_IMAGE_MODAL = "ShowImage";
export const SELECT_PRICE_CLASS_MODAL = "SelectPriceClass";
export const DELETE_ACCOUNT_NOTICE_MODAL = "DeleteAccountNotice";
export const LEAVE_EDIT_MODE_NOTICE_MODAL = "LeaveEditModeNotice";
export const REMOVE_LANG_NOTICE_MODAL = "RemoveLangNotice";
export const REMOVE_PAGE_NOTICE_MODAL = "RemovePageNotice";
export const EDIT_SLIDER_MODAL = "EditSlider";
export const EDIT_COLLECTION_MODAL = "EditCollection";
export const ATTENTION_REDIRECT_MODAL = "AttentionRedirect";
export const APPROVE_CHANGE_SEAT_MODAL = "ApproveChangeSeat";
export const SEAT_SHIFT_NOTIFY_MODAL = "SeatShiftNotify";
export const SETTING_SHOW_MORE = "SetttingShowMore";
export const MULTI_FLOOR_OCCUPIED_BUS_NOTICE_MODAL =
  "MultiFloorOccupiedBusNotice";
export const UPLOAD_IMAGE_MODAL = "UploadImage";
export const UPLOAD_IMAGES_MODAL = "UploadImages";
export const REMOVE_WIDGET_NOTICE_MODAL = "RemoveWidgetNotice";
export const DUBLICATE_PAGE_NOTICE_MODAL = "DublicatePageNotice";
export const ACCOUNT_INACTIVE_MODAL = "AccountInactive";

export const modalNames = [
  BASKET_EXPIRED_MODAL,
  BASKET_EXPIRED_CHANGE_MODAL,
  BUS_MODAL,
  CAMPAIGN_RULES_MODAL,
  DISCARDED_BASKET_MODAL,
  DISCARDED_BASKET_CHANGE_MODAL,
  FORGOT_PASSWORD_MODAL,
  LOGIN_MODAL,
  PARTNER_BUS_NOTICE_MODAL,
  REDEEM_VOUCHER_MODAL,
  REIDRECT_TO_PARTNERS_SITE_MODAL,
  RESULTS_OUT_OF_DATE_MODAL,
  SEARCH_DESTINATION_MOBILE_MODAL,
  SEARCH_PASSENGERS_MOBILE_MODAL,
  SEND_VOUHER_MODAL,
  UPDATE_BASKET_TIME_MODAL,
  UPDATE_BASKET_TIME_CHANGE_MODAL,
  SEND_PDF_MODAL,
  SHOW_IMAGE_MODAL,
  SELECT_PRICE_CLASS_MODAL,
  DELETE_ACCOUNT_NOTICE_MODAL,
  LEAVE_EDIT_MODE_NOTICE_MODAL,
  REMOVE_LANG_NOTICE_MODAL,
  REMOVE_PAGE_NOTICE_MODAL,
  EDIT_SLIDER_MODAL,
  EDIT_COLLECTION_MODAL,
  ATTENTION_REDIRECT_MODAL,
  APPROVE_CHANGE_SEAT_MODAL,
  SEAT_SHIFT_NOTIFY_MODAL,
  SETTING_SHOW_MORE,
  MULTI_FLOOR_OCCUPIED_BUS_NOTICE_MODAL,
  UPLOAD_IMAGE_MODAL,
  UPLOAD_IMAGES_MODAL,
  REMOVE_WIDGET_NOTICE_MODAL,
  DUBLICATE_PAGE_NOTICE_MODAL,
  ACCOUNT_INACTIVE_MODAL,
];
